import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type CustomiseSectionTitleClasses = 'title' | 'indicativeNumber';

const customiseSectionTitleStyles = makeStyles<ISpcTheme, CustomiseSectionTitleClasses>(
  () => ({
    title: {
      display: 'block',
      fontWeight: 'bold',
      position: 'relative',
    },
    indicativeNumber: {
      position: 'absolute',
      top: 0,
      width: 'fit-content',
    },
  }),
  { name: 'Customise_simpleBrands_CustomiseSectionTitle' },
);

export default customiseSectionTitleStyles;
